import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "menubar-container" }

import { computed } from "vue";
import { useSlots } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuBar',
  props: {
    leftItemClass: {},
    centerItemClass: {},
    rightItemClass: {},
    leftNowrap: { type: Boolean },
    centerNowrap: { type: Boolean },
    rightNowrap: { type: Boolean },
    withoutBorder: { type: Boolean },
    contentMenubar: { type: Boolean }
  },
  setup(__props: any) {



const slots = useSlots();

const slotRight = computed(() => {
  return !!slots["rightItems"];
});
const slotCenter = computed(() => {
  return !!slots["centerItems"];
});
const slotLeft = computed(() => {
  return !!slots["leftItems"];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["menubar", { 'border-0': _ctx.withoutBorder, 'content-menubar': _ctx.contentMenubar }])
    }, [
      (slotLeft.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["leftItems", [{ 'flex-nowrap': _ctx.leftNowrap }, _ctx.leftItemClass]])
          }, [
            _renderSlot(_ctx.$slots, "leftItems")
          ], 2))
        : _createCommentVNode("", true),
      (slotCenter.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["centerItems", [{ 'flex-nowrap': _ctx.centerNowrap }, _ctx.centerItemClass]])
          }, [
            _renderSlot(_ctx.$slots, "centerItems")
          ], 2))
        : _createCommentVNode("", true),
      (slotRight.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["rightItems", [{ 'flex-nowrap': _ctx.rightNowrap }, _ctx.rightItemClass]])
          }, [
            _renderSlot(_ctx.$slots, "rightItems")
          ], 2))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})